import { PayloadAction, createSlice } from 'ngrx-slice';

import { VipDiscountListByCompanyResponse } from '@app/api/models';

export interface State {
  //received discounts
  discountsReceived: Array<VipDiscountListByCompanyResponse>;
  discountsReceivedLoading: boolean;
  discountsReceivedLoadError: boolean;
}

export const initialState: State = {
  //received discounts
  discountsReceived: [],
  discountsReceivedLoading: false,
  discountsReceivedLoadError: false,
};

export const {
  actions: VipDiscountsBuyingActions,
  selectors,
  ...VipDiscountsBuyingFeature
} = createSlice({
  name: 'vipDiscountsBuying',
  initialState,
  reducers: {
    loadDiscountsReceived: {
      trigger: (state) => {
        state.discountsReceived = [];
        state.discountsReceivedLoading = true;
      },
      success: (
        state,
        action: PayloadAction<{
          response: Array<VipDiscountListByCompanyResponse>;
        }>
      ) => {
        state.discountsReceived = action.response;
        state.discountsReceivedLoading = false;
        state.discountsReceivedLoadError = false;
      },
      failure: (state) => ({
        ...state,
        discountsReceivedLoading: false,
        discountsReceivedLoadError: true,
      }),
    },
  },
});

export const VipDiscountsBuyingSelectors = {
  ...selectors,
};
